export default __webpack_public_path__ + "static/media/support-groups.490048db.jpg";